"use strict";
/*
* Created on 23.04.2019
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var LostSaleConverter_1 = require("./conversions/LostSaleConverter");

var LostSaleConverterImpl_1 = require("./conversions/LostSaleConverterImpl");

var StockoutConverter_1 = require("./conversions/StockoutConverter");

var StockoutConverterImpl_1 = require("./conversions/StockoutConverterImpl");
/**
 * Configures order suggested app module.
 *
 * @author ZSr
 */


var StockoutAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(StockoutAppModule, _AppModule_1$AppModul);

  function StockoutAppModule() {
    var _this;

    _classCallCheck(this, StockoutAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StockoutAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'stockoutAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(StockoutAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(StockoutConverter_1.StockoutConverter).to(StockoutConverterImpl_1.StockoutConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(LostSaleConverter_1.LostSaleConverter).to(LostSaleConverterImpl_1.LostSaleConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return StockoutAppModule;
}(AppModule_1.AppModule);

exports.StockoutAppModule = StockoutAppModule;